import * as R from "ramda";
import { getDefaultDataParams } from "./getDefaultDataParams.mjs";
import { getDefaultSelection } from "./getDefaultSelection.mjs";
import { getDefaultTableLayout } from "./getDefaultTableLayout.mjs";
import getAttributes from "./getAttributes.mjs";
import getDimensions from "./getDimensions.mjs";
import { getDataflowName } from "./getDataflowName.mjs";
import { getTimePeriod } from "./getTimePeriod.mjs";
import { getExternalResources } from "./getExternalResources.mjs";
import parseActualContentConstraints from "./parseActualContentConstraints.mjs";
import { parseMicrodataAnnotation } from "./parseMicrodataAnnotation.mjs";
import { constrainDimensions } from "./constrainDimensions.mjs";
const parseStructure = (structure) => {
  let contentConstraints = parseActualContentConstraints()(structure);
  const microdataDimensionId = parseMicrodataAnnotation()(structure);
  if (microdataDimensionId)
    contentConstraints[microdataDimensionId] = /* @__PURE__ */ new Set(["_T"]);
  return {
    contentConstraints,
    dimensions: R.pipe(
      getDimensions,
      (dimensions) => constrainDimensions(dimensions, contentConstraints)
    )(structure),
    attributes: getAttributes(structure),
    params: getDefaultDataParams(structure),
    selection: getDefaultSelection(structure),
    layout: getDefaultTableLayout(structure),
    timePeriod: getTimePeriod(structure),
    name: getDataflowName(structure),
    externalResources: getExternalResources(structure),
    microdataDimensionId
  };
};
export {
  parseStructure
};
